import routes from './routes';

const addModule = {
  routes,
};

export default addModule;
